"use client";

import { c as _c } from "react/compiler-runtime";
import CreateNoteWrapper from "../scribe/create-note-wrapper";
import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { AddOpportunityDialog } from "@/app/[tenant]/(console)/growth/leads/modals/add-opportunity-dialog";
import { CreateTaskModal } from "@/app/[tenant]/(console)/tasks/modals/create-task-modal";
import QuickNoteDialog from "@/components/custom-calendar/quick-note-dialog";
import SendFormsDialog from "@/components/forms/send-forms-dialog";
import CreatePatientModal from "@/components/patient/create-patient-modal";
import { useProgressNavigation } from "@/components/progress-bar";
import { useModule } from "@/hooks/use-module";
import { patientQueryOptions } from "@/api/provider/user/patient/patient-query";
import { CommandPaletteModal, useCommandPaletteModalsStore } from "@/stores/command-palette-modals-store";

/**
 * Global Command Palette Modals
 * Renders all modals that can be triggered from the command palette
 * using the existing modal components in controlled mode.
 */
export default function GlobalCommandPaletteModals() {
  const $ = _c(51);
  const {
    navigateWithProgress
  } = useProgressNavigation();
  const {
    activeModal,
    closeModal,
    prefill
  } = useCommandPaletteModalsStore();
  const hasGrowthModule = useModule("MARKETING");
  const pathname = usePathname();
  let patientId;
  let t0;
  let t1;
  if ($[0] !== pathname) {
    const patientIdMatch = pathname.match(/\/patient\/(usr_[^/]+)/);
    patientId = patientIdMatch ? patientIdMatch[1] : undefined;
    t1 = useQuery;
    t0 = patientQueryOptions.detail(patientId);
    $[0] = pathname;
    $[1] = patientId;
    $[2] = t0;
    $[3] = t1;
  } else {
    patientId = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  const t2 = !!patientId;
  let t3;
  if ($[4] !== t0 || $[5] !== t2) {
    t3 = {
      ...t0,
      enabled: t2
    };
    $[4] = t0;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: patient
  } = t1(t3);
  const t4 = activeModal === CommandPaletteModal.CREATE_PATIENT;
  let t5;
  if ($[7] !== closeModal) {
    t5 = open => !open && closeModal();
    $[7] = closeModal;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== navigateWithProgress) {
    t6 = patient_0 => navigateWithProgress(`/patient/${patient_0.id}`);
    $[9] = navigateWithProgress;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== prefill.createPatient || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <CreatePatientModal open={t4} onOpenChange={t5} onPatientCreate={t6} initialData={prefill.createPatient} />;
    $[11] = prefill.createPatient;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = activeModal === CommandPaletteModal.SEND_FORMS;
  let t9;
  if ($[16] !== closeModal) {
    t9 = open_0 => !open_0 && closeModal();
    $[16] = closeModal;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== patient || $[19] !== t8 || $[20] !== t9) {
    t10 = <SendFormsDialog open={t8} onOpenChange={t9} patient={patient} />;
    $[18] = patient;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = activeModal === CommandPaletteModal.CREATE_MEMO;
  let t12;
  if ($[22] !== closeModal) {
    t12 = open_1 => !open_1 && closeModal();
    $[22] = closeModal;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = prefill.createMemo?.event;
  let t14;
  if ($[24] !== patient || $[25] !== t11 || $[26] !== t12 || $[27] !== t13) {
    t14 = <QuickNoteDialog nonModal={true} open={t11} onOpenChange={t12} patient={patient} event={t13} />;
    $[24] = patient;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = activeModal === CommandPaletteModal.CREATE_NOTE;
  let t16;
  if ($[29] !== closeModal) {
    t16 = open_2 => !open_2 && closeModal();
    $[29] = closeModal;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== patient || $[32] !== t15 || $[33] !== t16) {
    t17 = <CreateNoteWrapper open={t15} onOpenChange={t16} patient={patient} />;
    $[31] = patient;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const t18 = activeModal === CommandPaletteModal.CREATE_TASK;
  let t19;
  if ($[35] !== closeModal) {
    t19 = open_3 => !open_3 && closeModal();
    $[35] = closeModal;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t18 || $[38] !== t19) {
    t20 = <CreateTaskModal open={t18} onOpenChange={t19} />;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== activeModal || $[41] !== closeModal || $[42] !== hasGrowthModule) {
    t21 = hasGrowthModule && activeModal === CommandPaletteModal.CREATE_OPPORTUNITY && <AddOpportunityDialog open={true} onOpenChange={open_4 => !open_4 && closeModal()} />;
    $[40] = activeModal;
    $[41] = closeModal;
    $[42] = hasGrowthModule;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t10 || $[45] !== t14 || $[46] !== t17 || $[47] !== t20 || $[48] !== t21 || $[49] !== t7) {
    t22 = <>{t7}{t10}{t14}{t17}{t20}{t21}</>;
    $[44] = t10;
    $[45] = t14;
    $[46] = t17;
    $[47] = t20;
    $[48] = t21;
    $[49] = t7;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  return t22;
}